import http from './base'
// let urls = 'images.zzsbx.com'
export default {

    index: function name(url,reg) {
        return http({
            method: "get",
            url: `/info/${url}`, //线上
            // url: `/info/${urls}`, //线上
            params:{
                url:url,
                region:reg
            },
        })
    },
    shopId: function name(url) { //获取shopId
        return http({
            method: "get",
            url: `/shopid/${url}`, //线上
            // url: `/shopid/${urls}`, //线上 
        })
    },
    region: function name(url) { //获取shopId
        return http({
            method: "get",
            url: `/region/${url}`, //线上
            // url: `/region/${urls}`, //线上
        })
    },
    shopUrl: function name(params) {
        return http({
            method: "get",
            params: params,
            url: `/shopUrl`,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/home.js